/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
import moment from 'moment'
import {
  required,
  pattern
} from '@/core/_helpers/validationRules'
import event from '@/util/event'

const formFieldsMixin = {
  data: () => ({
    rule: undefined,
    ruleLength: undefined,
    label: undefined,
    isValidateTriggered: false
  }),
  created () {
  },
  methods: {
    checkFormSanity (schema, model) {
      this.toggleEnable(schema, model)
      this.validateField(schema, model)
      // this.autoFill(schema, model)
    },
    validateField (schema, model) {
      Object.keys(schema).forEach((key) => {
        const mandateKey = schema[key]['conditional-mandate-disable']
        if (mandateKey) {
          if (model[key] && model[mandateKey]) {
            this.validateRegEx({ schema, key: mandateKey })
          } else if (model[key]) {
            delete schema[mandateKey].rules
            delete schema[mandateKey].id
            this.applyInputRules(schema, key, schema[key]['data-relation-rules'], true)
            this.validateRegEx({ schema, key })
          }
        }
      })
    },
    displayErrorMessage (component, content) {
      this.$store.dispatch('appStore/setAppData', {
        message: {
          content,
          type: 'error',
          component,
          timeOut: 3000,
          title: this.$t('form.invalid_accountNumber_attempts_message'),
          saveButton: this.$t('common.okay'),
          saveCallback: this.routeToHome,
          close: false,
          persistent: true
        }
      })
    },
    formatDate (inputDate, key, update = true, inputFormat = 'YYYY-MM-DD', outputFormat = 'DD-MM-YYYY') {
      let formatedDate
      const date = new Date(inputDate)
      const validateDateFormat = moment(inputDate, outputFormat, true).isValid() // validating the 'inputDate' against 'outputFormat' format

      if (isNaN(inputDate) && date.toString() !== 'Invalid Date') {
        if (!validateDateFormat) {
          formatedDate = moment(inputDate, inputFormat).format(outputFormat)
        }

        // if (update) {
        //   this.arg.config[this.config.name].model[key] = validateDateFormat ? inputDate : formatedDate
        //   this.$emit('update', this.arg.config[this.config.name].model)
        // }
      }

      return formatedDate
    },
    toggleDisable (model, { obj, schema, value }) {
      const schemaRelation = obj.schema['data-relation']
      const schemaRelationRules = obj.schema['data-relation-rules']
      const schemaDynRegex = obj.schema['data-dynRegex']
      const schemaRelationHide = obj.schema['data-relation-hide']

      if (schemaRelation && !schemaDynRegex) {
        for (let i = 0; i < schemaRelation.length; i++) {
          delete schema[schemaRelation[i]].rules
          delete schema[schemaRelation[i]].id
          this.applyInputRules(schema, schemaRelation[i], schemaRelationRules, value)
          if (schemaRelationHide) {
            this.applyInputRules(schema, schemaRelationHide, schemaRelationRules, !value)
          }
          if (value === false) {
            delete schema[schemaRelation[i]].rules
            delete schema[schemaRelation[i]].id
            schema[schemaRelation[i]].hidden = !value
          } else {
            if (schemaRelationHide) {
              delete schema[schemaRelationHide].rules
              delete schema[schemaRelationHide].id
            }
          }
          schema[schemaRelation[i]].hidden = !value
          if (schemaRelationHide) {
            schema[schemaRelationHide].hidden = value
          }
          this.arg.config[this.config.name].model[schemaRelation[i]] = ''
        }
      }
    },
    applyInputRules (schema, schemaRelation, schemaRelationRules, value) {
      if (schema && schema[schemaRelation]) {
        const applicableRules = ['required']
        if (!('rules' in schema[schemaRelation])) {
          Object.assign(schema[schemaRelation], { rules: [] })
        }
        schemaRelationRules.forEach((rule, index) => {
          if (applicableRules.includes(rule)) {
            schema[schemaRelation].id = (value) ? rule : ''
            schema[schemaRelation].rules[index] = (value) ? required('Required') : ''
          }
        })
      }
    },
    toggleEnable (schema, model) {
      if (schema && model) {
        Object.keys(schema).forEach((key) => {
          const keyEnable = schema[key]['data-relation']
          const keyDisable = schema[key]['data-relation-hide']
          if (keyEnable && keyDisable && model[key] && !schema[key]['data-dynRegex']) {
            for (let i = 0; i < keyEnable.length; i++) {
              schema[keyEnable[i]].hidden = false
              this.applyInputRules(schema, keyEnable[i], schema[key]['data-relation-rules'], model[key])
              if (schema[keyEnable[i]].hidden === false && keyDisable) {
                schema[keyDisable].hidden = true
                delete schema[keyDisable].rules
                delete schema[keyDisable].id
              }
              this.applyInputRules(schema, keyEnable[i], schema[key]['data-relation-rules'], model[key])
            }
          }
        })
      }
    },
    toggleManual (keys, flag = true) {
      if (keys) {
        // eslint-disable-next-line
        Object.keys(keys).filter((schemaKey) => {
          this.config.form.schema[schemaKey].readonly = flag
        })
      }
      if (flag) {
        event.$emit('disableSave', true)
      }
    },
    validateRegEx ({ schema, key }) {
      if (schema) {
        if (key in schema) {
          const { regex } = schema[key]
          if (!('rules' in schema[key])) {
            Object.assign(schema[key], { rules: [] })
          }
          if (regex) {
            schema[key].rules[5] = pattern(regex)
          }
        }
      }
    },
    toggleLabel (schema, model) {
      const filteredKey = Object.keys(schema).filter(key => schema[key].hasOwnProperty('data-dynRegex')).toString()

      if (filteredKey && model[filteredKey]) {
        const filterVal = (schema[filteredKey].items).filter(item => item.value === model[filteredKey])[0].text
        this.$store.dispatch('userStore/setUserData', { identifierLabel: filterVal })
        schema[schema[filteredKey]['data-relation']].label = filterVal
      }
    },
    toggleRegex ({
      schema, obj, value, key, data
    }) {
      if (obj.schema['data-dynRegex']) {
        const regexObj = obj.schema['data-regex']
        const dataRel = obj.schema['data-relation']

        if (!regexObj[value].regex) {
          return
        }
        this.rule = { [dataRel]: regexObj[value].regex }
        this.toggleLabel(schema, data)
        this.arg.config[this.config.name].model[dataRel] = ''
        this.$refs.form.resetValidation()
      // eslint-disable-next-line no-prototype-builtins
      } else if (this.rule && this.rule.hasOwnProperty(key)) {
        this.ruleLength = (!this.ruleLength) ? schema[key].rules.length : this.ruleLength
        schema[key].rules[this.ruleLength] = pattern(this.rule[key])
      }
    },
    autoFill (schema, model) {
      const filteredKey = Object.keys(schema).filter(key => schema[key].autoFill).toString()
      if (filteredKey && schema[filteredKey].autoFill['data-relation-value']) {
        const aKey = schema[filteredKey].autoFill['data-relation-value']

        Object.keys(schema).filter(key => {
          if (key === aKey) {
            model[aKey] = this.arg.config.store[aKey]
          }
        })
      }
    }
  }
}

export default formFieldsMixin
